<template>
  <div>
    <div class="loading" v-if="isLoading == true">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <b-row class="mb-3" v-if="$can('export')">
      <b-col sm>
        <div>
          <b-button variant="success" @click="exportTable" class="m-2">Export Crypto Transaction</b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search By Transaction Type :"
            label-for="sp"
          >
            <b-form-select id="sp" v-model="type" @change="doFilterType">
              <option value="">Filter By Crypto Product</option>
              <option v-for="(item, index) in cryptoOption" :key="index" :value="item.value">{{ item.text }}</option>
            </b-form-select>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search :"
            label-for="search"
            description="Searchable : Name, Email, Phone, Invoice No"
          >
            <b-input-group
            >
              <b-form-input
                id="search"
                type="search"
                v-model="filterText"
                placeholder="Name, Email, Phone, Invoice No ..."
                @keypress="doFilter"
                @keyup.delete="doFilter"
              >
              </b-form-input>
              <b-input-group-append
              >
                <b-button
                  variant="secondary" @click="resetFilter"
                  type="button"
                >
                  Reset
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Date :"
            label-for="daterange"
          >
            <b-input-group
            >
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <month-range-picker id="daterange" :start="startDate" :end="endDate" @picker="doDateFilter"></month-range-picker>
              <b-input-group-append>
                <b-button type="button" variant="secondary" @click="resetDateFilter">Reset</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>

    <vuetable ref="vuetable"
      @vuetable:load-error="handleLoadError"
      :api-url="apiUrl"
      :http-options="HttpOptions"
      :fields="fields"
      pagination-path=""
      :muti-sort="true"
      :sort-order="sortOrder"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData">
      <template slot="name-slot" slot-scope="prop">
        <router-link :to="onAction('view-user', prop.rowData, prop.rowIndex)" target="_blank">{{ prop.rowData.users.name }} ({{ prop.rowData.users.email }})</router-link>
        <span></span>
      </template>
      <template slot="type-slot" slot-scope="prop">
        <span>{{ prop.rowData.transaction_type }}</span>
      </template>
      <template slot="invoice_number-slot" slot-scope="prop">
        <span>{{ prop.rowData.invoice_number == null ? '-' : prop.rowData.invoice_number}}</span>
      </template>
      <template slot="source_crypto-slot" slot-scope="prop">
        <span>{{ prop.rowData.source_crypto }}</span>
      </template>
      <template slot="asset_amount-slot" slot-scope="prop">
        <span>{{ prop.rowData.asset_amount}} </span>
      </template>
      <template slot="trs_amount-slot" slot-scope="prop">
        <span>{{ prop.rowData.trs_amount}} </span>
      </template>
      <template slot="amount-slot" slot-scope="prop">
        <span>{{ prop.rowData.amount}} </span>
      </template>
      <template slot="status-slot" slot-scope="prop">
        <span>{{ prop.rowData.transaction_status}} </span>
      </template>
      <template slot="buying_rate-slot" slot-scope="prop">
        <span>{{ prop.rowData.buying_rate}} </span>
      </template>
      <template slot="selling_rate-slot" slot-scope="prop">
        <span>{{ prop.rowData.selling_rate}} </span>
      </template>
      <template slot="actions-slot" slot-scope="prop">
        <div class="custom-actions">
          <button class="btn btn-success" @click="onAction('detail-item', prop.rowData)">Detail</button>
        </div>
      </template>
    </vuetable>
    <div class="vuetable-pagination ui basic segment grid">
      <vuetable-pagination-info ref="paginationInfo"
      ></vuetable-pagination-info>

      <vuetable-pagination ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Vue from 'vue'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
  import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

  let startDate = '';
  let endDate = '';
  Vue.use(Vuetable);

  export default {
    components: {
      Vuetable,
      VuetablePagination,
      VuetablePaginationInfo,
    },
    prop: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    data() {
      return {
        startDate: '',
        endDate: '',
        type: '',
        filterText: '',
        isLoading: false,
        cryptoOption: '',
        errors: {
          code: '',
          message: '',
          status: ''
        },
        typeOptions: [
          { value: '', text: 'All' },
          { value: 'beli_asset', text: 'Beli Asset' },
          { value: 'jual_asset', text: 'Jual Asset' },
          { value: 'top_up', text: 'Top Up' },
          { value: 'withdraw', text: 'Withdraw' },
        ],
        apiUrl: process.env.VUE_APP_SECRET + process.env.VUE_APP_CONFIG + `crypto-transaction`,
        HttpOptions: {
          headers: {
            'Accept' : 'application/json',
            'Authorization' : 'Bearer ' + localStorage.getItem('access_token')
          }
        },
        sortOrder: [
          {
            field: 'crypto_transaction.created_at',
            sortField: 'crypto_transaction.created_at',
            direction: 'desc'
          }
        ],
        moreParams: {},
        fields: [
          {
            name: 'created_at',
            sortField: 'crypto_transaction.created_at',
            title: 'Date'
          },
          {
            name: 'name-slot',
            sortField: 'users.name',
            title: 'User'
          },
          {
            name: 'type-slot',
            title: 'Transaction Type'
          },
          {
            name: 'source_crypto-slot',
            title: 'Asset Crypto'
          },
          {
            name: 'invoice_number-slot',
            title: 'Invoice'
          },
          {
            name: 'trs_amount-slot',
            title: 'Asset Amount',
          },
          {
            name: 'asset_amount-slot',
            title: 'Asset TKO Amount',
          },
          {
            name: 'amount-slot',
            title: 'IDR Amount',
          },
          {
            name: 'status-slot',
            title: 'Transaction Status'
          },
          {
            name: 'buying_rate-slot',
            title: 'Asset Buy TRS Price'
          },
          {
            name: 'selling_rate-slot',
            title: 'Asset Sell TRS Price'
          },
          {
            name: 'actions-slot',
            title: 'Actions',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          }
        ]
      }
    },
    created() {
      axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access_token')}`
      axios.get(process.env.VUE_APP_SECRET + 'admin/v2/command/crypto-command').then((response) => {
        this.cryptoOption = response.data.data
        this.type = cryptoOption[0].value
      })
    },
    methods: {
      onAction (action, data) {
        if (action == 'view-user') {
          return { name: 'Detail End User', params: { id: btoa(data.users.id)} }
        }else if (action == 'detail-item') {
          this.$router.push({name: 'Detail Crypto Transaction History', params: { id: data.id}})
        }
      },
      npwpVal(value) {
        return value != null ? value : '-'
      },
      doFilter () {
        this.$events.$emit('filter-set', this.filterText)
      },
      doFilterType () {
        this.$events.$emit('type-set', this.type)
      },
      resetFilter () {
        this.filterText = ''  // clear the text in text input
        this.$events.$emit('filter-reset')
      },
      exportTable() {
        this.isLoading = true
        if (this.startDate != '' && this.endDate != '') {
          startDate = this.startDate;
          endDate = this.endDate;
        }else{
          endDate = this.$setDate.format('YYYY-MM-DD');
          startDate = this.$setDate.subtract(6, 'days').format('YYYY-MM-DD');
        }
        this.$http.get(`crypto-transactions/` + startDate + '/' + endDate)
        .then((result) => {
          this.isLoading = false
          const  exportPath = result.data.meta.data;
          window.location.href = exportPath;
        }).catch((error) => {
          if (error.response) {
            this.isLoading = false
            this.errors.code = error.response.status;
            this.errors.status = error.response.data.meta.code;
            this.errors.headers = error.response.headers;
          }
        })
      },
      handleLoadError(error) {
        this.errors.code = error.response.data.meta.code;
        this.errors.message = error.response.data.meta.message;
        this.errors.status = error.response.data.meta.code;
        if (this.errors.code == 401) {
          if (localStorage.getItem('access_token') != null) {
            localStorage.removeItem('access_token');
            this.$swal.fire(
              'Your session expired!',
              'Your session has expired. Please login again to access this page!',
              'error'
            ).then(() =>{
              this.$router.push("/login")
            })
          }
        }else if(this.errors.code == 403) {
          this.$router.push("/403")
        }else if(this.errors.code == 500) {
          this.$router.push("/500")
        }
      },
      resetDateFilter () {
        this.startDate = ''  // clear the text in text input
        this.endDate = ''
        this.$events.$emit('date-filter-reset')
      },
      allcap (value) {
        return value.toUpperCase()
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
        this.$refs.paginationInfo.setPaginationData(paginationData)
      },
      onFilterSet (filterText) {
          this.search = filterText
          this.moreParams = {
              'filter': this.search,
              'type' : this.type,
              'start_from': this.startDate,
              'end_to': this.endDate
          }
          Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      onTypeFilterSet () {
        this.moreParams = {
          'filter': this.search,
          'type' : this.type,
          'start_from': this.startDate,
          'end_to': this.endDate
        }
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      doDateFilter(value){
        this.startDate = value.startDate;
        this.endDate = value.endDate;
        this.$events.fire('date-set', [this.startDate, this.endDate])
      },
      onDateSet()  {
        this.moreParams = {
          'filter': this.search,
          'type' : this.type,
          'start_from': this.startDate,
          'end_to': this.endDate
        }
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      onFilterReset () {
          this.moreParams = {}
          Vue.nextTick( () => this.$refs.vuetable.refresh())
      },
      onDateFilterReset () {
        this.moreParams = {}
        Vue.nextTick( () => this.$refs.vuetable.refresh())
      }
    },
    mounted() {
      this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
      this.$events.$on('date-set', eventData => this.onDateSet(eventData))
      this.$events.$on('type-set', eventData => this.onDateSet(eventData))
      this.$events.$on('filter-reset', () => this.onFilterReset())
      this.$events.$on('date-filter-reset', () => this.onDateFilterReset())
    },
  }
</script>
<style>
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
